import { ProfileProvider } from '@/providers/profile/profile.provider';
import { FeatureCode } from '@/utils/disabled-features/disabled-features.interface';
import { DisabledFeaturesService } from '@/utils/disabled-features/disabled-features.service';
import { inject, Injectable } from '@angular/core';
import { type CanActivateChildFn, type CanActivateFn, Router } from '@angular/router';
import { of, type Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ThermalComfortFeatureService {
    private _router = inject(Router);
    private _disabledFeaturesService = inject(DisabledFeaturesService);
    private _profileProvider = inject(ProfileProvider);

    goToFeature() {
        this._router.navigate(['/', 'thermal-comfort']);
    }

    hasFeatureAccess$(): Observable<boolean> {
        if (!this._disabledFeaturesService.isFeatureEnabled(FeatureCode.THERMAL_COMFORT)) {
            return of(false);
        }
        return this._profileProvider.hasInternalModuleAccess$();
    }

    async hasFeatureAccess(): Promise<boolean> {
        if (!this._disabledFeaturesService.isFeatureEnabled(FeatureCode.THERMAL_COMFORT)) {
            return false;
        }
        return this._profileProvider.hasInternalModuleAccess();
    }
}

export const thermalComfortGuard: CanActivateFn & CanActivateChildFn = async () => {
    const featureService = inject(ThermalComfortFeatureService);
    const hasFeatureAccess = await featureService.hasFeatureAccess();

    if (!hasFeatureAccess) {
        return false;
    }
    return true;
};
